import React, { useState } from "react";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";
import { FaBars } from "react-icons/fa";
import "./navbar.css";
import navLogo from "../../assets/navLogo.png";
import discord from "../../assets/discord.svg";
import twitter from "../../assets/twitter.svg";
import instagram from "../../assets/instagram.svg";
const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
//  Menu Function Start 
  const Menu = () => (
    <>
      <p>Mint a Potato</p>
      <p>Rarity</p>
      <p>Roadmap</p>
      <p>Team</p>
      <p>FAQ</p>
      <p>Provenance</p>
      <h1>
      <a href="https://discord.gg/nu9BZtVtTU" target="_blank">
        <img src={discord} alt="discord" />
      </a>
      </h1>
      <h1 style={{marginLeft: '3rem'}}>
      <a href="https://twitter.com/PartyPotatoNFT" target="_blank">
        <img src={twitter} alt="twitter" />
      </a>
      </h1>
      <h1 style={{marginLeft: '3rem'}}>
      <a href="https://www.instagram.com/partypotatonft/" target="_blank">
        <img src={instagram} alt="instagram"/>
      </a>
      </h1>
    </>
  );
//  Menu Function End

  return (
    <div className="gpt3__navbar">
      <div
        className="gpt3__navbar-links"
      >
        {/* menuAndlinks */}
        <div
          className="menuAndlinks"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div className="gpt3__navbar-links_logo">
            <img src={navLogo} alt="logo" />
          </div>
          <div className="gpt3__navbar-links-container">
            <Menu/>
          </div>
        </div>
        {/* buttonAndBars */}
        <div className="buttonAndBars">
          {/* Button */}
          <div className="gpt3__navbar-sign">
            <button type="button">CONNECT WALLET</button>
          </div>
          {/* Bars */}
          <div className="gpt3__navbar-menu">
            {toggleMenu ? (
              <RiCloseLine
                color="#67A3E8"
                size={40}
                onClick={() => setToggleMenu(false)}
              />
            ) : (
              <FaBars
                color="#67A3E8"
                size={40}
                onClick={() => setToggleMenu(true)}
              />
            )}
            {toggleMenu && (
              <div className="gpt3__navbar-menu_container scale-up-center">
                <div className="gpt3__navbar-menu_container-links">
                  <Menu />
                  <div className="gpt3__navbar-menu_container-links-sign">
                    <button type="button">CONNECT WALLET</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
